import React, {useState} from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { getQuotaForApproval, rejectMultiple, setState, Upload } from "./quotaModificationApprovalSlice";
import { Button, TextField, Typography, Grid } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 400,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 2,
   borderRadius: 1,
};

export default function RejectSelectedModal() {
   const dispatch = useDispatch();
   const [uploadedEditFile, setuploadedEditFile] = useState([]);
   const {
      rejectSelModalOpen,
      rejectSelectedComment,
      selectedCountryID,
      selectedPeriod,
      selectedQuotaStatus,
      quotaList,
      selectedQuotaid,
      searchText,
      isButtonClicked,
      selectedRowsselected
   } = useSelector((store) => store.quotaModification);

   function handleClose() {
      dispatch(setState("rejectSelModalOpen", false));
      dispatch(setState("isButtonClicked", false));
      dispatch(setState("rejectSelectedComment", ''));
      dispatch(setState("files",[]));
      dispatch(setState("selectedQuotaid",null));
		setuploadedEditFile([]);
      dispatch(setState("filepaths",[]));
   }

   function setComment(event) {
      const comment = event.target.value;
      dispatch(setState("rejectSelectedComment", comment));
   }

   function search() {
      dispatch(setState("rejectSelectedComment", ''));
      dispatch(setState("selectedRowsselected", []));
      dispatch(setState("scenarioModificationList",null));
      dispatch(setState("expandedRowIndex",null));
      dispatch(setState("files",[]));
	   setuploadedEditFile([]);
      dispatch(setState("filepaths",[]));
      dispatch(setState("selectedQuotaid",null));
      const logedUser = JSON.parse(localStorage.getItem("data"));
      const countryId = selectedCountryID;
      const period = selectedPeriod;
      const quotaStatus = selectedQuotaStatus;

      const obj = {
         countryId,
         period,
         quotaStatus,
         logedUser,
         searchText: searchText,
      };
      dispatch(getQuotaForApproval(obj));
   }

   function rejectSelected() {
      let quotaLst = [];
      const user = JSON.parse(localStorage.getItem("data"));
      if(!isButtonClicked){
        let quota = quotaList.find((item) => item.quotaId === selectedQuotaid);
        quota = {
            ...quota,
            rejectionComments: rejectSelectedComment,
        }
        const obj = {
            ...quota,
            user,
        };
      quotaLst.push(obj);
      }else{
         for (let i = 0; i < selectedRowsselected.length; ++i) {
            let quota = quotaList.find((item) => item.quotaId === selectedRowsselected[i].quotaId);
            quota = {
               ...quota,
               rejectionComments: rejectSelectedComment,
            }
            console.log(quota);
            const obj = {
               ...quota,
               user,
            };
            quotaLst.push(obj);
         }
      }
      console.log("Approve_Modification_RejectSelected", quotaLst);
      dispatch(Upload({method : "POST"})).then(() => {
      dispatch(rejectMultiple(quotaLst)).then(() => {
        search();
      });
      handleClose();
   });
   }
   const handleFileUpload = (event) => {
      const fileObj = event.target.files[0];
      let file = [...uploadedEditFile];
      file.push(fileObj);
      setuploadedEditFile(file);
      dispatch(setState("files", file));
    };
  
    const handleDelete = (name) => {
      const file = uploadedEditFile.filter((file) => file.name !== name);
      setuploadedEditFile(file);
      dispatch(setState("files", file));
    };

   return (
      <Box>
         <Modal open={rejectSelModalOpen} onClose={handleClose}>
            <Box sx={style}>
               <Typography variant="subtitle2">Comments</Typography>
               <TextField
                  className={'fullWidth'}
                  size="large"
                  multiline
                  rows={6}
                  style={{overflowY:'auto'}}
                  value={rejectSelectedComment}
                  onChange={setComment}
               />
               <br />
               <Grid item>
                  <Box>
                     <input
                        type="file"
                        onChange={handleFileUpload}
                        style={{ display: 'none' }}
                        id="fileInput"
                        onclick="fileInput.value = null"
                        value=""
                     />
                     <label htmlFor="fileInput">
                        <Button
                           variant="contained"
                           sx={{
                              bgcolor: "darkred.light",
                              color: "white.main",
                              textTransform: "none",
                              mt: 1,
                              "&:hover": {
                                 bgcolor: "darkred.main",
                                 color: "white.main",
                              },
                           }}
                           component="span"
                        >
                           Upload File
                        </Button>
                     </label>
                  </Box>
               </Grid>
               <Grid>
                  {uploadedEditFile.map((file) => (
                      <Box sx={{ mt: 2, borderBottom: 0.25, borderColor: "#e0e0e0" }}>
                       <div className="file-display" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                           <span>{file.name}</span>
                           {/* <Button variant="outlined" color="secondary" onClick={() => handleDelete(file.name)}> */}
                           <DeleteIcon onClick={() => handleDelete(file.name)} sx={{ cursor: "pointer" }} />
                           {/* </Button> */}
                        </div>
                     </Box>
                  ))}
               </Grid>
               <br />
               <Box
                  sx={{
                     display: "flex",
                     flexDirection: "row",
                     justifyContent: "flex-end",
                  }}
               >
                  <Button
                     sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        mt: 1,
                        mr: 2,
                        "&:hover": {
                           bgcolor: "darkred.main",
                           color: "white.main",
                        },
                     }}
                     onClick={handleClose}
                  >
                     Close
                  </Button>

                  <Button
                     sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        mt: 1,
                        "&:hover": {
                           bgcolor: "darkred.main",
                           color: "white.main",
                        },
                     }}
                     onClick={rejectSelected}
                  >
                     Reject
                  </Button>
               </Box>

            </Box>
         </Modal>
      </Box>
   );
}
